import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CreditSafeRecommendedCreditLimitSchema = z
    .object({
        amount: z.number(),
        currency: z.string(),
    })
    .strict();

export class CreditSafeRecommendedCreditLimit extends FromSchema(CreditSafeRecommendedCreditLimitSchema) {
    amount: number;
    currency: string;
}
